import styled from "styled-components";

export const VerticalContainer = styled.div`
  display: flex;
  flex-direction: column;
  gap: 16px;

  span {
    display: flex;
    flex-direction: column;
    gap: 16px;
  }
`;

export const HorizontalContainer = styled.div`
  display: grid;
  grid-template-columns: 50% 50%;
  gap: ${(props) => props.itemsGap || "14px"};
`;
